
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { priceRulesEl } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";
import _ from "lodash-es";

const finance = namespace("finance");
const base = namespace("base");
const app = namespace("app");
const setting = namespace("setting");

@Component({})
export default class CreateOtherReceipt extends Vue {
  @finance.Action createOtherReceipt;
  @finance.Action queryOtherReceiptReceiptTypes;
  @base.Action getDictionaryList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.Action getPatternPaymentList;
  API_URL = window.API_URL;
  get breadData() {
    return [
      { name: t("finance.receipt"), path: "/finance/collection-order" },
      { name: t("finance.create-new-receipt") }
    ];
  }
  payWayList: any[] = [];
  receiptFormData = {
    payerName: "",
    paidMethod: "",
    receiptAmount: "",
    paidTime: "",
    remark: "",
    secondaryReceiptTypeCas: ["9", "901"],
    receiptType: "9",
    secondaryReceiptType: "901"
  };
  receiptFormRules = {
    paidMethod: [{ required: true, message: t("finance.select-mode-payment"), trigger: "change" }],
    paidTime: [{ required: true, message: t("v216_6.please-select-the-receipt-time"), trigger: "change" }],
    receiptAmount: [
      {
        required: true,
        message: t("finance.enter-amount-receive")
      },
      { validator: this.checkPrice, trigger: "blur" }
    ],
    payerName: [{ required: true, message: t("finance.enter-payer"), trigger: "blur" }],
    remark: [{ required: true, message: t("v210831.please-enter-a-digest"), trigger: "blur" }]
  };
  otherReceiptReceiptTypesList = [];
  otherReceiptReceiptTypesProps: any = {
    label: "dataDesc",
    value: "dataValue",
    children: "childReceiptTypeList"
  };
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  created() {
    this.init();
  }
  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        this.addOtherReceipt();
      } else {
        console.log("error submit!!");
      }
    });
  }
  async init() {
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = this.$safeValue(data, "data", []);
    });
    this.getOtherReceiptReceiptTypes();
  }
  async getOtherReceiptReceiptTypes() {
    const res = await this.queryOtherReceiptReceiptTypes();
    this.otherReceiptReceiptTypesList = this.addLeafFlag(res.data || []);
    // const secondaryReceiptType = this.otherReceiptReceiptTypesList?.[0]?.childReceiptTypeList?.[0]?.dataValue;
    // this.receiptFormData.secondaryReceiptType = secondaryReceiptType ?? "";
    // this.receiptFormData.secondaryReceiptType = ["9", "901"]; //默认取值901-其他收款-其他收入
  }
  // 过滤空children
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.childReceiptTypeList || item.childReceiptTypeList.length < 1) {
          delete item.childReceiptTypeList;
        } else {
          f(item.childReceiptTypeList);
        }
      });
    };
    f(list);
    return list;
  }
  async addOtherReceipt() {
    this.btnStartLoading();

    this.createOtherReceipt({ ..._.omit(this.receiptFormData, ["secondaryReceiptTypeCas"]) })
      .then(() => {
        this.$message.success(t("base.success") as any);
        this.$router.push(`/finance/collection-order`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  changeCasReceiptType(data) {
    this.receiptFormData.receiptType = data[0];
    // 判断是否选择了第二级
    this.receiptFormData.secondaryReceiptType = data && data.length > 1 ? data[1] : "";
  }
}
